import React from "react";
import { Navigate, useLocation, Outlet, useNavigate } from "react-router-dom";
import getCookie, { AuthToken } from "../components/Common/Utils";
import { useAuth } from "../Context/authContext";
import { Spin } from "antd";
// import Navbar from '../Componets/Common/Navbar'
// import { ADMIN, TEAM_ADMIN } from '../Componets/Common/StaticDatas'

export const ProtectedRoutes = () => {
  const auth = useAuth();
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  // const isAuthenticated = () => getCookie("detection_auth");
  // if (!AuthToken.isValid()) {
  //   return <Navigate to="/" />;
  // }
  if (loading) {
    return (
      <>
        {" "}
        <div className="loading-overlay">
          <Spin
            size="default"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1,
              opacity: 0.8,
            }}
          />
        </div>
      </>
    );
  }

  if (!user || Object.keys(user).length === 0) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!AuthToken.isValid()) {
    return <Navigate to="/" replace />;
  }
  if (!auth.user.isAdmin) {
    navigate("/");
  }
  return (
    <div>
      <div className="cpr-layout-inside">
        <Outlet />
      </div>
    </div>
  );
};
